import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getEmailOptInStats(salonId, token) {
  const res = await axios.get(`${API}/marketing/email-opt-in/stats`, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function searchEmailOptInClients(payload, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/clients/search`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function searchEmailOptOutClients(payload, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-outs/clients/search`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function exportEmailOptOutClients(payload, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-outs/clients/export`,
    payload,
    {
      headers: authHeaders(token),
      responseType: "blob",
    }
  );
  return res;
}

export async function updateEmailOptOutClientPreference(clientId, payload, token) {
  const res = await axios.put(
    `${API}/marketing/email-opt-outs/clients/${clientId}/preferences`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateEmailOptOutClientStatus(clientId, payload, token) {
  const res = await axios.put(
    `${API}/marketing/email-opt-outs/clients/${clientId}/status`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getEmailOptInTemplate(salonId, token) {
  const res = await axios.get(`${API}/marketing/email-opt-in/template`, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateEmailOptInTemplate(salonId, payload, token) {
  const res = await axios.put(`${API}/marketing/email-opt-in/template`, payload, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function resetEmailOptInTemplate(salonId, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/template/reset-default`,
    {},
    {
      params: { salon_id: salonId },
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function createInviteBatch(payload, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/invite-batches`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function previewInviteBatch(batchId, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/invite-batches/${batchId}/preview`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function sendInviteBatch(batchId, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/invite-batches/${batchId}/send`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function createFeedbackBatch(payload, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/feedback-batches`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function sendFeedbackBatch(batchId, token) {
  const res = await axios.post(
    `${API}/marketing/email-opt-in/feedback-batches/${batchId}/send`,
    {},
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function subscribeEmailOptIn(payload) {
  const res = await axios.post(`${API}/marketing/email-opt-in/subscribe`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}

export async function unsubscribeEmailOptIn(payload) {
  const res = await axios.post(`${API}/marketing/email-opt-in/unsubscribe`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}

export async function submitEmailOptInFeedback(payload) {
  const res = await axios.post(`${API}/marketing/email-opt-in/feedback`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
}

export async function getEmailSubscriptionSummary(payload, token) {
  const res = await axios.post(`${API}/reports/email-subscription/summary`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getEmailSubscriptionTrends(payload, token) {
  const res = await axios.post(`${API}/reports/email-subscription/trends`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getEmailSubscriptionReasons(payload, token) {
  const res = await axios.post(`${API}/reports/email-subscription/reasons`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getEmailSubscriptionPreferences(payload, token) {
  const res = await axios.post(`${API}/reports/email-subscription/preferences`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getEmailSubscriptionBatches(payload, token) {
  const res = await axios.post(`${API}/reports/email-subscription/batches`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
